<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap fill-height xs12>
      <v-flex xs12>
        <v-progress-linear
          v-if="showProgress"
          :indeterminate="true"
          color="accent"
          :active="showProgress"
          height="2"
        ></v-progress-linear>
      </v-flex>
      <v-flex xs12>
        <big-title
          :item-reason="itemReason"
          :row-type="rowType"
          :auth="auth"
        ></big-title>
      </v-flex>

      <v-flex xs12 sm12 md6 lg6 xl6>
        <content-table v-if="itemObj"
          :items="[itemObj]"
          :contentHeading="contentHeading"
          :item-type="rowType"
          :item-name="itemName"
          :item-reason="itemReason"
          :all-prizes="allPrizes"
          :story-header="storyHeader"
        ></content-table>
      </v-flex>

      <v-flex xs12 sm12 md6 lg6 xl6>
        <big-content
          :row-types="rowTypes"
          :item="item"
          :all-prizes="allPrizes"
        ></big-content>
      </v-flex>



    </v-layout>
  </v-container>
</template>
<script>
import Contenttable from '@/components/Contenttable'

import Bigcontent from '@/components/Bigcontent'
import Bigtitle from '@/components/Bigtitle'
import { mapMutations } from 'vuex'
import { vxMaps } from '@/js/vxstore'
export default {
  props: {
    showProgress: Boolean,
    itemReason: Object,
    rowType: String,
    item: Object,
    contentHeading: String,
    itemObj: Object,
    itemName: String,
    rowTypes: Array,
    allPrizes: Array,
    auth: Object,
    storyHeader: String
  },
  created () {
    // otherwise the vuex store will contain stuff about a different film
    this.clearStack()
    this.setSlideIndex(-1)
  },
  methods: {
    ...mapMutations(vxMaps.mutations)
  },
  components: {
    'content-table': Contenttable,
    'big-content': Bigcontent,
    'big-title': Bigtitle
  }
}
</script>
